// common app constants

export const NO_DATA_AVAILABLE = 'No data available';
